/* eslint-disable no-return-assign */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoginContext } from '../App';
import GroupAudioCallScreen from '../UiComponents/CallScreen/components/GroupAudioCallScreen';
import GroupCallReceiveScreen from '../UiComponents/CallScreen/components/GroupCallReceiveScreen';
import FullWidthLoader from '../components/Common/Loaders/FullWidthLoader';
import CustomSidenav from '../containers/BusinessSettings/Components/CustomSidenav';
import '../containers/BusinessSettings/styles.css';
import OngoingCallPopup from '../containers/Contacts/components/OngoingCallPopup';
import useUpdateStorage from '../containers/LicenseSubscription/customHooks/useGetStorage';
import OneTimeRecognisationPopUp from '../containers/Recognition/components/OneTimeRecognisationPopUp';
import ExitPopup from '../containers/TrainingWebinar/TWScreen/components/ExistPopup';
import ForcedLogoutPopup from '../UiComponents/ForcedLogoutPopup';
import { chatUnreadCount } from '../containers/actions/chat_actions';
import { getCongratulationPopUp } from '../containers/actions/recognition_actions';
import { CallContext, HamburgerContext, LanguageContext } from '../libs/Context';
import useStoreEmpty from '../libs/CustomHooks/useStoreEmpty';
import useLogout from '../components/Hooks/useLogout';
import { getSocketSessionId, queryParams } from '../libs/HelperContent';
import { updatechatUnreadCount } from '../redux/ChatRedux';
import { fetchRecogniseData } from '../redux/RecogniseRedux';
import { getDealData, getNotification, getProfileData, getSharedItem, initialChatFetchApi } from '../redux/UserSessionSlice';
import NewCopyrightFooter from '../UiComponents/Footer/NewCopyrightFooter';
import ProfileSettingsNav from '../containers/ProfileSettings';
import useAnalyticsTrigger from '../libs/CustomHooks/useAnalyticsTrigger';

const CompanyHoc = (WrappedComponent) =>
{
	return function NewComponent(props)
	{
		const { language } = useContext(LanguageContext);
		const activePath = window.location.pathname.split('/')[1];
		const activePath2 = window.location.pathname.split('/')[2];
		const currentPathname = window.location.pathname;
		const session = useSelector((state) => state?.mysession?.session);
		const initialStatus = useSelector((state) => state?.mysession?.initialStatus);
		const dispatch = useDispatch();
		const { contactHamBurger, showSideNavIcons } = useContext(HamburgerContext);
		const unreadCount = useSelector((state) => state?.mychat?.chatUnreadCount);
		const { loading } = useContext(LoginContext);
		const { socket, call, setCall, setCatTab } = useContext(LoginContext);
		const { callStream, setCallStream, isOnline } = useContext(CallContext);
		const { fetchUser } = useContext(LoginContext);
		const [ congratsPopUp, setCongratsPopUp ] = useState([]);
		const recognise = useSelector((state) => state?.myrecognise?.recognise?.recognise);
		const eachPost = new URLSearchParams(window.location.search).get('post');
		const [ sessionExpired, setSessionExpired ] = useState(false);
		const [ forcedLogout, setForcedLogout ] = useState(false);
		const navigate = useNavigate();
		const setStorageData = useUpdateStorage();
		const emptyReduxState = useStoreEmpty();
		const share = new URLSearchParams(window.location.search).get('share');
		const handleLogout = useLogout();
		const isLogOutRef = useRef(false);

		const [ hideSideNavInContent, setHideSideNavInContent ] = useState(false);

		useAnalyticsTrigger();

		// Auth page paths that don't require authentication
		const AUTH_PAGES = [ '/', '/login', '/signup', '/forgot-password', '/otp-verify', '/password-reset' ];

		// Pages that show custom side navigation
		const BUSINESS_SETTINGS_PATH = '/businessSettings';
		const PROFILE_SETTINGS_PATH = '/profileSettings';
		const CREATE_TEMPLATE_PATH = '/createNewTemplate';

		// Pages that hide footer
		const FOOTER_HIDDEN_PAGES = [
			BUSINESS_SETTINGS_PATH,
			'/contacts',
			PROFILE_SETTINGS_PATH,
			'/profile',
			'/me',
			'/certification',
			'/training',
			'/trainingDetails',
			CREATE_TEMPLATE_PATH,
			'/businessProfile',
			'/collaboration'
		];

		// Content pages that show footer
		const CONTENT_PAGES_WITH_FOOTER = [
			'/businessSettings/content/video',
			'/businessSettings/content/creation',
			'/businessSettings/content/image',
			'/businessSettings/content/articleCreation',
			'/businessSettings/content/podcast'
		];

		// Check if user has admin/superAdmin access
		const hasAdminAccess = session?.empRole !== 'employee';

		// Check if employee is inactive (pending, reject, or deactive)
		const isInactiveEmployee = session?.isActive === 'pending' ||
			session?.isActive === 'reject' ||
			session?.isActive === 'deactive';

		// Check if current page is an auth page
		const isOnAuthPage = AUTH_PAGES.includes(currentPathname) || currentPathname === '/';

		// Check if should show business settings sidenav
		const showBusinessSettingsSidenav = currentPathname.includes(BUSINESS_SETTINGS_PATH) && hasAdminAccess;

		// Check if should show profile settings sidenav
		const showProfileSettingsSidenav = currentPathname.includes(PROFILE_SETTINGS_PATH);

		// Check if should hide footer
		const shouldHideFooter = contactHamBurger ||
			FOOTER_HIDDEN_PAGES.some((page) => currentPathname.includes(page)) ||
			(`/connections/${activePath2}` === '/connections/profile');

		// Check if should show footer on content pages
		const isContentPageWithFooter = currentPathname.includes('/businessSettings/content') &&
			!CONTENT_PAGES_WITH_FOOTER.includes(currentPathname);

		// Determine main container class
		const getMainContainerClass = () =>
		{
			if (currentPathname.includes(PROFILE_SETTINGS_PATH) ||
				currentPathname.includes(CREATE_TEMPLATE_PATH) ||
				showBusinessSettingsSidenav)
			{
				return 'innerMainCntnrContact';
			}

			return showSideNavIcons ? 'innerMainCntnrMob' : 'innerMainCntnr';
		};

		// Determine content container class
		const getContentContainerClass = () =>
		{
			const baseClass = 'flexCol fullHeight';
			const customClass = hideSideNavInContent ? 'CustomMainCntrres' : 'CustomMainCntr';
			const templateClass = currentPathname.includes(CREATE_TEMPLATE_PATH) ? '' : customClass;
			const responsiveClass = currentPathname.includes('/insideInlynk') ? 'respdngXS' : '';

			if (showSideNavIcons)
			{
				return `${baseClass} ${responsiveClass}`;
			}

			return `${baseClass} ${templateClass} ${responsiveClass}`;
		};

		const handleBroadcastMessage = (event) =>
		{
			if (event.data === 'userSignedOut')
			{
				setSessionExpired(true);
			}
		};

		// Defensive reset on every Business Settings mount: other modules
		// (Chat, Meetings, etc.) set `document.body.style.overflow = 'hidden'`
		// without cleanup, so the lock can survive navigation and break scroll
		// on every Business module except Dashboard. Repro: Chat → expand the
		// side nav → click Manage Business → no scroll.
		useEffect(() =>
		{
			document.body.style.overflow = 'unset';
		}, []);

		useEffect(() =>
		{
			const broadcastChannel = new BroadcastChannel('signOutChannel');

			broadcastChannel.addEventListener('message', handleBroadcastMessage);

			const hasSession = Object.keys(session)?.length > 0;
			const isInactiveEmployee = session?.isActive === 'pending' ||
				session?.isActive === 'reject' ||
				session?.isActive === 'deactive';

			if (hasSession)
			{
				// Redirect inactive employees to employee page
				if (isInactiveEmployee)
				{
					navigate('/emp');
				}
			}
			else
			{
				// Handle share parameter
				if (share)
				{
					localStorage.setItem('shareNetwork', share);
				}

				// Clear redux state if user had a session
				if (session?.userId)
				{
					emptyReduxState();
				}

				const currentPath = window.location.pathname.split('/').filter(Boolean);
				const hasPath = currentPath.length > 0;

				// Redirect to login if not on auth page and has no session
				if (!hasSession && hasPath && !isOnAuthPage)
				{
					navigate('/', { replace: true });
				}
			}

			return () =>
			{
				broadcastChannel.removeEventListener('message', handleBroadcastMessage);
			};
		}, [ session ]);

		const clearTracks = () =>
		{
			callStream?.getTracks().forEach((track) => { track.stop(); });
			setCallStream(null);
			setCall({ state: false, type: null, roomId: null, callBy: null, members: null });
		};

		const setIncomingCall = useCallback((data) =>
		{
			if (data?.roomType === 'group')
			{
				setCall({ ...data, status: true, inapi: null });
			}
			else
			{
				setCall({ ...data, status: true });
			}
		}, [ socket ]);

		const setChatCount = useCallback((data) =>
		{
			if (window.location.pathname !== '/contacts' && data?.sentBy !== session?.userId)
			{
				if (data.from === 'single' && !unreadCount?.single?.includes(data?.roomId))
				{
					dispatch(updatechatUnreadCount({ single: [ ...unreadCount.single, data?.roomId ], group: unreadCount?.group }));
				}
				else if (data.from === 'group' && !unreadCount?.group?.includes(data?.roomId))
				{
					dispatch(updatechatUnreadCount({ single: unreadCount?.single, group: [ ...unreadCount.group, data?.roomId ] }));
				}
				session.userId !== data?.sentBy && socket.emit('receive_msg', data?.roomId, 'room', data?.sentBy);
			}
		}, [ socket, unreadCount ]);

		const getchatUnreadCount = async () =>
		{
			try
			{
				const shouldFetchChatCount = session?.userId && initialStatus === 1;
				
				if (shouldFetchChatCount)
				{
					const readCount = await chatUnreadCount();
					const hasValidChatData = readCount?.status && readCount.data?.single && readCount.data?.group;

					if (hasValidChatData)
					{
						const totalUnreadCount = readCount.data.single.length + readCount.data.group.length;
						
						dispatch(updatechatUnreadCount({
							total  : totalUnreadCount,
							single : readCount.data.single,
							group  : readCount.data.group
						}));
						dispatch(initialChatFetchApi(2));
					}
					
					if (readCount)
					{
						const dealData = {
							dealConnection : readCount?.dealConnection,
							dealStatus     : readCount?.dealStatus
						};
						
						dispatch(getDealData(dealData));
						dispatch(getNotification(readCount?.unreadCount));
					}
				}
			}
			catch (e)
			{
				console.log(e);
			}
		};

		const congratulationPopUp = async () =>
		{
			const queryParamRes = queryParams(session?.userId, session?.companyId, session?.empRole, session?.role, 'get');
			const query = `?status=true${queryParamRes}`;

			getCongratulationPopUp(query)
				.then((res) =>
				{
					if (!res?.status)
					{
						throw new Error(`HTTP error: ${res?.data}`);
					}

					setCongratsPopUp(res?.data);
					dispatch(fetchRecogniseData({ recognise: true }));
				})
				.catch((e) =>
				{
					dispatch(fetchRecogniseData({ recognise: false }));
					console.log('Error', e);
				});
		};

		const deleteUsedStorage = () =>
		{
			const unfinishedUploads = JSON.parse(localStorage.getItem('unfinishedUploads') ?? '{}');
			const updatedRemovedData = { ...unfinishedUploads };

			for (const key in unfinishedUploads)
			{
				if (key)
				{
					setStorageData({ action: 'del', ownerCompanyId: key, size: unfinishedUploads[key] })
						.then(() =>
						{
							delete updatedRemovedData[key];

							if (Object.keys(updatedRemovedData).length === 0) localStorage.removeItem('unfinishedUploads');
						});
				}
			}
		};

		useEffect(() =>
		{
			deleteUsedStorage();
			// Only make API calls if employee is active (not pending/reject/deactive)
			const isActiveEmployee = session?.isActive === 'active';

			setTimeout(() =>
			{
				if (isActiveEmployee && !recognise && session?.role !== 'individual' && Object?.keys(session ?? {})?.length !== 0)
				{
					congratulationPopUp();
				}
				if (isActiveEmployee)
				{
					getchatUnreadCount();
				}
			}, 2000);
		}, []);

		useEffect(() =>
		{
			if (socket)
			{
				socket.on('incoming_call', setIncomingCall);

				socket.off('chat_count').on('chat_count', setChatCount);

				socket.off('on_end_call').on('on_end_call', (data) =>
				{
					if (call?.roomId === data?.roomId)
					{
						setCall({ status: false, type: null, callBy: null, roomId: null });
					}
				});
				socket.off('on_leave_call').on('on_leave_call', (data) =>
				{
					if (call?.roomId === data?.roomId)
					{
						setCall({ ...call, roomUsers: data?.roomUsers });
					}
				});

				socket.off('self_call').on('self_call', () =>
				{
					clearTracks();
					toast.error(language?.youAlreadyOngoingCall, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
				});

				socket.off('call_busy').on('call_busy', () =>
				{
					clearTracks();
					toast.error(language?.userOnotherCall, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
				});

				socket.on('on_call_check', (status) =>
				{
					if (!status)
					{
						clearTracks();
						setCall({ status: false });
					}
				});

				socket.off('stop_call').on('stop_call', () =>
				{
					clearTracks();
					setCall({ status: false, type: null, callBy: null, roomId: null });
				});

				return () =>
				{
					socket.off('self_call');
					socket.off('on_end_call');
					socket.off('chat_count');
					socket.off('incoming_call');
					socket.off('stop_call');
					socket.off('on_leave_call');
					socket.off('on_call_check');
				};
			}
		}, [ call, callStream, unreadCount ]);

		useEffect(() =>
		{
			if (!socket)
			{
				return undefined;
			}

			const handleLogOutFromAllDevices = (data) =>
			{
				const isLogoutEvent = data?.type === 'log_out_from_all_devices';
				const isTargetUser = data?.userId === session?.userId || data?.masterId === session?.masterId;

				if (isLogoutEvent && isTargetUser && !isLogOutRef.current)
				{
					isLogOutRef.current = true;
					setForcedLogout(true);
					// Delay logout to show the popup
					setTimeout(() =>
					{
						handleLogout();
					}, 2000);
				}
			};

			const handleForcedLogout = (data) =>
			{
				console.log('data******', data);
				if (data?.sessionId === getSocketSessionId())
				{
					setForcedLogout(true);
					// Delay logout to show the popup
					setTimeout(() =>
					{
						handleLogout();
					}, 2000);
				}
			};

			socket.off('log_out_from_all_devices').on('log_out_from_all_devices', handleLogOutFromAllDevices);
			socket.off('forced_logout').on('forced_logout', handleForcedLogout);

			return () =>
			{
				socket.off('log_out_from_all_devices', handleLogOutFromAllDevices);
			};
		}, [ socket, session?.userId, session?.masterId, handleLogout ]);

		useEffect(() =>
		{
			if (call?.roomId && !call?.callCheck)
			{
				isOnline && socket.emit('on_updates', { type: 'on_call_check', roomId: call?.roomId });
			}
		}, [ isOnline, call, socket ]);

		useEffect(() =>
		{
			if (socket)
			{
				socket.off('user_actions').on('user_actions', (data) =>
				{
					setCatTab(0);

					if (data?.userId === session?.userId && data?.action === 'deactivated')
					{
						socket?.emit('conference_call', { type: 'leaveCall' }, { roomId: call?.roomId });
						// console.log('conference call in HOC 1');

						dispatch(getProfileData({ isActive: 'deactive' }));
						navigate('/emp', {
							state : {
								type : 'deactivate'
							}
						});
					}
					else if (data?.userId === session?.userId && data?.action === 'adminAccess')
					{
						socket.emit('conference_call', { type: 'leaveCall' }, { roomId: call?.roomId });
						// console.log('conference call in HOC 2');

						fetchUser();
						dispatch(getProfileData({ empRole: session?.empRole !== 'admin' ? 'admin' : 'employee' }));
					}
				});

				return () =>
				{
					socket.off('user_actions');
				};
			}
		}, [ socket, call ]);
		useEffect(() =>
		{
			if (socket)
			{
				socket.off('on_create_recognition').on('on_create_recognition', (data) =>
				{
					if (session?.userId === data?.userId && data?.type === 'on_create_recognition')
					{
						const recogData = {
							...data.data,
							employeeData : { userId: session?.userId, name: session?.firstName, thumbnailImage: session?.thumbnailImage, profileImage: session?.profileImage }
						};

						setCongratsPopUp([ recogData, ...congratsPopUp ]);
					}
				});
				socket.off('on_close_recognition').on('on_close_recognition', () => setCongratsPopUp([]));

				return () =>
				{
					socket.off('on_close_recognition');
				};
			}
		}, [ socket, session, congratsPopUp ]);

		useEffect(() =>
		{
			if (eachPost !== null)
			{
				dispatch(getSharedItem(eachPost));
			}
		}, [ eachPost ]);

		let callComponent = '';
		const isGroupCall = call?.status && call?.roomType === 'group';
		const isCallInitiator = call?.callBy?.userId === session?.userId;
		const isOngoingCall = call?.reason === 'ongoing_call';
		const callLabel = call?.type === 'audio' ? language?.GAudiocall : language?.GVideoCall;

		if (isGroupCall)
		{
			if (isOngoingCall)
			{
				callComponent = <OngoingCallPopup />;
			}
			else if (isCallInitiator)
			{
				callComponent = <GroupAudioCallScreen label={callLabel} />;
			}
			else
			{
				callComponent = <GroupCallReceiveScreen label={callLabel} />;
			}
		}

		const mainContainerClass = getMainContainerClass();
		const contentContainerClass = getContentContainerClass();
		const sidenavClass = hideSideNavInContent ? 'CustomSideNavres brdrRght' : 'CustomSideNav';

		return (
			<>
				<div className='flexCol fullHeight'>
					{/* added userId to restrict api calls when userid is not available */}
				{/* also prevent rendering for inactive employees to avoid unnecessary API calls */}
					{!loading && session?.userId && !isInactiveEmployee && (
						<div className={`${mainContainerClass} sideNav`}>
							{showBusinessSettingsSidenav && (
								<div className={sidenavClass}>
									<CustomSidenav
										setHideSideNavInContent={setHideSideNavInContent}
										hideSideNavInContent={hideSideNavInContent}
									/>
								</div>
							)}

							{showProfileSettingsSidenav && (
								<div className='CustomSideNav'>
									<ProfileSettingsNav/>
								</div>
							)}

							<div className={contentContainerClass}>
								<React.Suspense fallback={<FullWidthLoader />}>
									<WrappedComponent {...props} />
								</React.Suspense>

								{!shouldHideFooter && <NewCopyrightFooter />}
								{isContentPageWithFooter && <NewCopyrightFooter />}
							</div>
						</div>
					)}
					{callComponent}

					{congratsPopUp?.length > 0 && (
						<OneTimeRecognisationPopUp
							open={congratsPopUp?.length > 0}
							setCongratsPopUp={setCongratsPopUp}
							congratsPopUp={congratsPopUp}
						/>
					)}
					{sessionExpired && (
						<ExitPopup
							open={sessionExpired}
							title='Session Expired'
							info='Session has been Expired.'
							button='reload'
							setSessionExpired={setSessionExpired}
						/>
					)}
					{forcedLogout && <ForcedLogoutPopup open={forcedLogout} />}
				</div>
			</>
		);
	};
};

export default CompanyHoc;